import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReservationSummaryStoreService } from '../../services/reservation-summary-store.service';
import { Payment, Reservation, SummaryPayments, SummaryPaymentsValues } from '../../../reservation.model';
import { PaymentStatus } from '@/common/enums/paymentStatus';
import { Subject, combineLatest, filter, takeUntil } from 'rxjs';

@Component({
	selector: 'app-reservation-summary-payments-summary',
	templateUrl: './reservation-summary-payments-summary.component.html',
	styleUrls: ['./reservation-summary-payments-summary.component.scss'],
})
export class ReservationSummaryPaymentsSummaryComponent implements OnInit, OnDestroy {
	summaryPaymentData: SummaryPayments = {
		totalPrice: {
			value: 0,
			name: 'Wartość Rezerwacji',
			disable: false,
		},
		paymentBalance: {
			value: 0,
			name: 'Zapłacono',
			disable: false,
		},
		commissionValue: {
			value: 0,
			name: 'Prowizja',
			disable: false,
		},
		totalPriceWithoutCommission: {
			value: 0,
			name: 'Wartość rezerwacji bez prowizji agenta',
			disable: false,
		},
		balanceWithoutCommission: {
			value: 0,
			name: 'Pozostało do zapłaty przez Agenta',
			disable: false,
		},
		balance: {
			value: 0,
			name: 'Pozostało do zapłaty przez Klienta',
			disable: false,
		},
	};
	dataSource: SummaryPaymentsValues[] = [];
	displayedColumns: string[] = ['paymentName', 'price'];

	private readonly destroy$: Subject<void> = new Subject();

	constructor(private readonly store: ReservationSummaryStoreService) {}

	ngOnInit() {
		const { payment, reservation } = this.store.getters();
		combineLatest([reservation(), payment()])
			.pipe(
				filter(([result, val]) => !!result && !!val),
				takeUntil(this.destroy$),
			)
			.subscribe(([result, val]) => {
				this.setSummaryPayments(result, val);
			});
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}

	setSummaryPayments(result: Reservation, val: Payment[]) {
		let paymentBalance = 0;
		val.filter((v) => v.status === PaymentStatus.COMPLETED).forEach((payment) => {
			paymentBalance += payment.amount;
		});
		this.summaryPaymentData.balanceWithoutCommission.disable = result.seller.isOskar;
		this.summaryPaymentData.balance.disable = !result.seller.isOskar;
		this.summaryPaymentData.totalPrice.value = result?.totalPrice;
		this.summaryPaymentData.paymentBalance.value = paymentBalance;
		this.summaryPaymentData.commissionValue.value = result?.commissionValue;
		this.summaryPaymentData.totalPriceWithoutCommission.value = result?.totalPrice - result?.commissionValue;
		this.summaryPaymentData.balanceWithoutCommission.value = result?.balanceWithoutCommission;
		this.summaryPaymentData.balance.value = result?.balance;
		let data: SummaryPaymentsValues[] = [];
		Object.keys(this.summaryPaymentData).forEach((item) => {
			data = [...data, this.summaryPaymentData[item]];
		});
		this.dataSource = data;
	}
}
